import {
  SingleSelectData,
  SingleSelectElement,
} from "@redotech/redo-model/forge/review-forge-types";
import { memo, useContext, useState } from "react";
import { Flex } from "../../flex";
import { FieldConfig, InspectorConfig } from "../../inspector";
import { RadioGroup } from "../../radio";
import { Text } from "../../text";
import { BrandKitContext } from "../review-form-editor-contexts";

export const ReviewSingleSelect = memo(function ReviewSingleSelect({
  element,
  setData,
  data,
  showRequired,
}: {
  element: SingleSelectElement<number>;
  setData: (data: SingleSelectData) => void;
  data?: SingleSelectData;
  showRequired: boolean;
}) {
  const brandKit = useContext(BrandKitContext);

  const [value, setValue] = useState<string | undefined>();

  function handleValueChange(value: string | undefined) {
    if (!value) {
      return;
    }
    setValue(value);
    setData?.({ type: element.type, selectedOption: value });
  }

  const realValue = data?.selectedOption || value;

  const fontFamily = brandKit.font.bodyFontFamily; // NOTE: Assuming body font is used for single select

  const showRequiredState = showRequired && element.required;

  return (
    <Flex style={{ fontFamily }}>
      <RadioGroup
        optionLabel={(option) => option}
        options={element.options}
        value={realValue}
        valueChange={(value) => {
          handleValueChange(value);
        }}
      />
      {showRequiredState && (
        <Text fontSize="sm" style={{ fontFamily }} textColor="error">
          This question is required
        </Text>
      )}
    </Flex>
  );
});

export function getReviewSingleSelectInspector(
  element: SingleSelectElement<number>,
): InspectorConfig<SingleSelectElement<number>> {
  const fields: FieldConfig<SingleSelectElement<number>>[] = [];

  for (const [index, option] of element.tag.metadata.options.entries()) {
    fields.push({
      widget: "text",
      label: `Response: ${option}`,
      description: "How this option will appear in the form",
      path: `options.${index}` as "type",
    });
  }

  return {
    sections: [
      {
        label: "Single select",
        fields: [
          { widget: "toggle", path: "required", label: "Required" },
          ...fields,
        ],
      },
    ],
  };
}
